import { default as _91_46_46_46cms_93dDta8t2Eg2Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/[...cms].vue?macro=true";
import { default as _91_46_46_46slug_939kO88uia6RMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/3d-projects/[...slug].vue?macro=true";
import { default as index4bF5qT1gluMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/3d-projects/index.vue?macro=true";
import { default as _91_46_46_46slug_93HQbeMetiWGMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/akcii/[...slug].vue?macro=true";
import { default as index5mpVUFTg0UMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/akcii/index.vue?macro=true";
import { default as _91_46_46_46slug_93eNm67C75rIMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/articles/[...slug].vue?macro=true";
import { default as indexqfbh3CrijrMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/articles/index.vue?macro=true";
import { default as indexPbhuh1aZmwMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/authorization/index.vue?macro=true";
import { default as indexnJoHbwPrgkMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/cart/index.vue?macro=true";
import { default as _91_46_46_46id_93b1QacU8gcUMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/cart/success/[...id].vue?macro=true";
import { default as _91_46_46_46slug_93V2TrIaIp6nMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/catalog/[...slug].vue?macro=true";
import { default as index7rD1F2no3cMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/catalog/index.vue?macro=true";
import { default as _91_46_46_46slug_93J6aA3qJhIqMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/catalogsearch/[...slug].vue?macro=true";
import { default as resultJiM4sDL7xtMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/catalogsearch/result.vue?macro=true";
import { default as indexykBXrUWl7sMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/clear-page-slider/index.vue?macro=true";
import { default as _91_46_46_46slug_93J69CHqh7ODMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/collection/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93iB6WKBEB4GMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/fabriki/[...slug].vue?macro=true";
import { default as indexBOK4oyWRN3Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/fabriki/index.vue?macro=true";
import { default as _91hash_93iDAtcC5XX1Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/order-status/[hash].vue?macro=true";
import { default as _91_46_46_46slug_93zS1TxSdVdLMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/product/[...slug].vue?macro=true";
import { default as indexZDvcobwJnuMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/profile/index.vue?macro=true";
import { default as indexVt7ZPH7KYLMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/profile/orders/index.vue?macro=true";
import { default as indexCQDryxg0HkMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/recently/index.vue?macro=true";
import { default as _91_46_46_46slug_93vu3iOZVq3QMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/sets/[...slug].vue?macro=true";
import { default as index2rl9z5tCAZMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/wishlist/index.vue?macro=true";
export default [
  {
    name: _91_46_46_46cms_93dDta8t2Eg2Meta?.name ?? "cms",
    path: _91_46_46_46cms_93dDta8t2Eg2Meta?.path ?? "/:cms(.*)*",
    meta: _91_46_46_46cms_93dDta8t2Eg2Meta || {},
    alias: _91_46_46_46cms_93dDta8t2Eg2Meta?.alias || [],
    redirect: _91_46_46_46cms_93dDta8t2Eg2Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/[...cms].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_939kO88uia6RMeta?.name ?? "3d-projects-slug",
    path: _91_46_46_46slug_939kO88uia6RMeta?.path ?? "/3d-projects/:slug(.*)*",
    meta: _91_46_46_46slug_939kO88uia6RMeta || {},
    alias: _91_46_46_46slug_939kO88uia6RMeta?.alias || [],
    redirect: _91_46_46_46slug_939kO88uia6RMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/3d-projects/[...slug].vue").then(m => m.default || m)
  },
  {
    name: index4bF5qT1gluMeta?.name ?? "3d-projects",
    path: index4bF5qT1gluMeta?.path ?? "/3d-projects",
    meta: index4bF5qT1gluMeta || {},
    alias: index4bF5qT1gluMeta?.alias || [],
    redirect: index4bF5qT1gluMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/3d-projects/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93HQbeMetiWGMeta?.name ?? "akcii-slug",
    path: _91_46_46_46slug_93HQbeMetiWGMeta?.path ?? "/akcii/:slug(.*)*",
    meta: _91_46_46_46slug_93HQbeMetiWGMeta || {},
    alias: _91_46_46_46slug_93HQbeMetiWGMeta?.alias || [],
    redirect: _91_46_46_46slug_93HQbeMetiWGMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/akcii/[...slug].vue").then(m => m.default || m)
  },
  {
    name: index5mpVUFTg0UMeta?.name ?? "akcii",
    path: index5mpVUFTg0UMeta?.path ?? "/akcii",
    meta: index5mpVUFTg0UMeta || {},
    alias: index5mpVUFTg0UMeta?.alias || [],
    redirect: index5mpVUFTg0UMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/akcii/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93eNm67C75rIMeta?.name ?? "articles-slug",
    path: _91_46_46_46slug_93eNm67C75rIMeta?.path ?? "/articles/:slug(.*)*",
    meta: _91_46_46_46slug_93eNm67C75rIMeta || {},
    alias: _91_46_46_46slug_93eNm67C75rIMeta?.alias || [],
    redirect: _91_46_46_46slug_93eNm67C75rIMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/articles/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexqfbh3CrijrMeta?.name ?? "articles",
    path: indexqfbh3CrijrMeta?.path ?? "/articles",
    meta: indexqfbh3CrijrMeta || {},
    alias: indexqfbh3CrijrMeta?.alias || [],
    redirect: indexqfbh3CrijrMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/articles/index.vue").then(m => m.default || m)
  },
  {
    name: indexPbhuh1aZmwMeta?.name ?? "authorization",
    path: indexPbhuh1aZmwMeta?.path ?? "/authorization",
    meta: indexPbhuh1aZmwMeta || {},
    alias: indexPbhuh1aZmwMeta?.alias || [],
    redirect: indexPbhuh1aZmwMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/authorization/index.vue").then(m => m.default || m)
  },
  {
    name: indexnJoHbwPrgkMeta?.name ?? "cart",
    path: indexnJoHbwPrgkMeta?.path ?? "/cart",
    meta: indexnJoHbwPrgkMeta || {},
    alias: indexnJoHbwPrgkMeta?.alias || [],
    redirect: indexnJoHbwPrgkMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/cart/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46id_93b1QacU8gcUMeta?.name ?? "cart-success-id",
    path: _91_46_46_46id_93b1QacU8gcUMeta?.path ?? "/cart/success/:id(.*)*",
    meta: _91_46_46_46id_93b1QacU8gcUMeta || {},
    alias: _91_46_46_46id_93b1QacU8gcUMeta?.alias || [],
    redirect: _91_46_46_46id_93b1QacU8gcUMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/cart/success/[...id].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93V2TrIaIp6nMeta?.name ?? "catalog-slug",
    path: _91_46_46_46slug_93V2TrIaIp6nMeta?.path ?? "/catalog/:slug(.*)*",
    meta: _91_46_46_46slug_93V2TrIaIp6nMeta || {},
    alias: _91_46_46_46slug_93V2TrIaIp6nMeta?.alias || [],
    redirect: _91_46_46_46slug_93V2TrIaIp6nMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/catalog/[...slug].vue").then(m => m.default || m)
  },
  {
    name: index7rD1F2no3cMeta?.name ?? "catalog",
    path: index7rD1F2no3cMeta?.path ?? "/catalog",
    meta: index7rD1F2no3cMeta || {},
    alias: index7rD1F2no3cMeta?.alias || [],
    redirect: index7rD1F2no3cMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/catalog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93J6aA3qJhIqMeta?.name ?? "catalogsearch-slug",
    path: _91_46_46_46slug_93J6aA3qJhIqMeta?.path ?? "/catalogsearch/:slug(.*)*",
    meta: _91_46_46_46slug_93J6aA3qJhIqMeta || {},
    alias: _91_46_46_46slug_93J6aA3qJhIqMeta?.alias || [],
    redirect: _91_46_46_46slug_93J6aA3qJhIqMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/catalogsearch/[...slug].vue").then(m => m.default || m)
  },
  {
    name: resultJiM4sDL7xtMeta?.name ?? "catalogsearch-result",
    path: resultJiM4sDL7xtMeta?.path ?? "/catalogsearch/result",
    meta: resultJiM4sDL7xtMeta || {},
    alias: resultJiM4sDL7xtMeta?.alias || [],
    redirect: resultJiM4sDL7xtMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/catalogsearch/result.vue").then(m => m.default || m)
  },
  {
    name: indexykBXrUWl7sMeta?.name ?? "clear-page-slider",
    path: indexykBXrUWl7sMeta?.path ?? "/clear-page-slider",
    meta: indexykBXrUWl7sMeta || {},
    alias: indexykBXrUWl7sMeta?.alias || [],
    redirect: indexykBXrUWl7sMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/clear-page-slider/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93J69CHqh7ODMeta?.name ?? "collection-slug",
    path: _91_46_46_46slug_93J69CHqh7ODMeta?.path ?? "/collection/:slug(.*)*",
    meta: _91_46_46_46slug_93J69CHqh7ODMeta || {},
    alias: _91_46_46_46slug_93J69CHqh7ODMeta?.alias || [],
    redirect: _91_46_46_46slug_93J69CHqh7ODMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/collection/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93iB6WKBEB4GMeta?.name ?? "fabriki-slug",
    path: _91_46_46_46slug_93iB6WKBEB4GMeta?.path ?? "/fabriki/:slug(.*)*",
    meta: _91_46_46_46slug_93iB6WKBEB4GMeta || {},
    alias: _91_46_46_46slug_93iB6WKBEB4GMeta?.alias || [],
    redirect: _91_46_46_46slug_93iB6WKBEB4GMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/fabriki/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexBOK4oyWRN3Meta?.name ?? "fabriki",
    path: indexBOK4oyWRN3Meta?.path ?? "/fabriki",
    meta: indexBOK4oyWRN3Meta || {},
    alias: indexBOK4oyWRN3Meta?.alias || [],
    redirect: indexBOK4oyWRN3Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/fabriki/index.vue").then(m => m.default || m)
  },
  {
    name: _91hash_93iDAtcC5XX1Meta?.name ?? "order-status-hash",
    path: _91hash_93iDAtcC5XX1Meta?.path ?? "/order-status/:hash()",
    meta: _91hash_93iDAtcC5XX1Meta || {},
    alias: _91hash_93iDAtcC5XX1Meta?.alias || [],
    redirect: _91hash_93iDAtcC5XX1Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/order-status/[hash].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93zS1TxSdVdLMeta?.name ?? "product-slug",
    path: _91_46_46_46slug_93zS1TxSdVdLMeta?.path ?? "/product/:slug(.*)*",
    meta: _91_46_46_46slug_93zS1TxSdVdLMeta || {},
    alias: _91_46_46_46slug_93zS1TxSdVdLMeta?.alias || [],
    redirect: _91_46_46_46slug_93zS1TxSdVdLMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/product/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexZDvcobwJnuMeta?.name ?? "profile",
    path: indexZDvcobwJnuMeta?.path ?? "/profile",
    meta: indexZDvcobwJnuMeta || {},
    alias: indexZDvcobwJnuMeta?.alias || [],
    redirect: indexZDvcobwJnuMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexVt7ZPH7KYLMeta?.name ?? "profile-orders",
    path: indexVt7ZPH7KYLMeta?.path ?? "/profile/orders",
    meta: indexVt7ZPH7KYLMeta || {},
    alias: indexVt7ZPH7KYLMeta?.alias || [],
    redirect: indexVt7ZPH7KYLMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/profile/orders/index.vue").then(m => m.default || m)
  },
  {
    name: indexCQDryxg0HkMeta?.name ?? "recently",
    path: indexCQDryxg0HkMeta?.path ?? "/recently",
    meta: indexCQDryxg0HkMeta || {},
    alias: indexCQDryxg0HkMeta?.alias || [],
    redirect: indexCQDryxg0HkMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/recently/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93vu3iOZVq3QMeta?.name ?? "sets-slug",
    path: _91_46_46_46slug_93vu3iOZVq3QMeta?.path ?? "/sets/:slug(.*)*",
    meta: _91_46_46_46slug_93vu3iOZVq3QMeta || {},
    alias: _91_46_46_46slug_93vu3iOZVq3QMeta?.alias || [],
    redirect: _91_46_46_46slug_93vu3iOZVq3QMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/sets/[...slug].vue").then(m => m.default || m)
  },
  {
    name: index2rl9z5tCAZMeta?.name ?? "wishlist",
    path: index2rl9z5tCAZMeta?.path ?? "/wishlist",
    meta: index2rl9z5tCAZMeta || {},
    alias: index2rl9z5tCAZMeta?.alias || [],
    redirect: index2rl9z5tCAZMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929062206/pages/wishlist/index.vue").then(m => m.default || m)
  }
]